// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___mCWsk","readMoreButton":"styles__readMoreButton___1F73d"};